exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".answer-row{width:90px}.answer-row p{font-family:Monospaced,monospace;font-size:12px}.field>div>input{margin:3px auto;display:inline-block}.field>div .btn{padding:3px;font-size:12px}", ""]);

